import React from "react";
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import Helmet from "react-helmet";
import carefoodies from '../../public/assets/carefoodies-grid.png';
import eightwaves from '../../public/assets/eightwaves.png';
import careerclinic from '../../public/assets/careerclinic.png';
import ketomau from '../../public/assets/ketomau.png';
import game from '../../public/assets/game.png';
import Obfuscate from "react-obfuscate";
import Link from 'gatsby-link';




export default props  => (
  <div className="c-content-box" style={{paddingTop: "3em"}}>


    <HeadlineWithFocus>
    <span> Cool stuff </span> I have built
    </HeadlineWithFocus>
    <div className="projects" style={{ width: "90vw", marginTop: "1em", display: "flex", flexWrap: "nowrap", overflowX: "scroll", overflowY: "hidden", whiteSpace: "no wrap"}}>

    <div className="gallery" style={{width: "400px", height: "250px", padding: "0 1em 1em", border: "1px solid white", borderRadius: "6px",  margin: "2em 2em 2em 0", flex: "0 0 auto"}}>
     <div className="gallery-image">
     <a href="https://stark-thicket-79076.herokuapp.com/" target="_blank">
     <img className="img-responsive" src={carefoodies} alt="logo"/>
     <div className="gallery-text">

        <h3 className="hidden1">Node.js & SQL</h3>

    </div>
    </a>
    </div>


    </div>
    <div className="gallery" style={{width: "400px", height: "250px", padding: "0 1em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto"}}>
    <div className="gallery-image">
    <a href="https://eightwaves.herokuapp.com/" target="_blank">
    <img className="img-responsive" src={eightwaves} alt="logo"/>
     <div className="gallery-text">

        <h3 className="hidden1">React.js & Rails</h3>

    </div>
    </a>
    </div>
    </div>
    <div className="gallery" style={{width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px",margin: "2em", flex: "0 0 auto"}}>
    <div className="gallery-image">
    <a href="https://career-clinic.herokuapp.com/" target="_blank">
    <img className="img-responsive" src={careerclinic} alt="logo"/>
     <div className="gallery-text">

        <h3 className="hidden">Rails & Postgres</h3>

    </div>
    </a>
    </div>
    </div>
    <div className="gallery" style={{width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto"}}>
     <div className="gallery-image">
     <a href="http://www.ketomau.com" target="_blank">
     <img className="img-responsive" src={ketomau} alt="logo"/>
      <div className="gallery-text">

        <h3 className="hidden">WordPress</h3>

    </div>
    </a>
    </div>
    </div>
    <div className="gallery" style={{width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto"}}>
     <div className="gallery-image">
     <a href="https://mau-dev.github.io/Project1-What-is-underneath/" target="_blank">
     <img className="img-responsive" src={game} alt="logo"/>
      <div className="gallery-text">

        <h3 className="hidden">JavaScript & DOM</h3>

    </div>
    </a>
    </div>
    </div>




    </div>
      {/*<h2
        className={`
        js-action-button-anchor
        c-content-box__subheadline
        c-content-box__subheadline--with-button
      `}
      >
        Contact
      </h2> */}
  </div>
);


// WEBPACK FOOTER //
// ./src/pages/projects.jsx